/**
 * OC Chat Footer Component
 * Footer with optional disclaimer text and feedback button
 * Only displays after user has sent their first message (not in initial state)
 */

import React from 'react';

import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';
import ShareFeedbackButton from '../Feedback/ShareFeedbackButton';
import { FooterContainer, FooterContent, FooterText } from './OcChatFooter.styled';

export interface OcChatFooterProps {
  isNarrow?: boolean;
}

/**
 * OcChatFooter Component
 * Displays footer with optional text and feedback button inside the input area
 * Shown after initial state (matching behavior of ReactRoot widget)
 */
export const OcChatFooter: React.FC<OcChatFooterProps> = ({
  isNarrow = false,
}) => {
  const { footerText, showFeedbackButton } = useOcFabWidgetOptions();

  // Don't render if no content to show
  if (!footerText && !showFeedbackButton) {
    return null;
  }

  // Show feedback button only on wide screens
  const shouldShowFeedback = showFeedbackButton && !isNarrow;

  return (
    <FooterContainer>
      <FooterContent $showFeedback={shouldShowFeedback}>
        <FooterText>{footerText}</FooterText>
        {shouldShowFeedback && <ShareFeedbackButton />}
      </FooterContent>
    </FooterContainer>
  );
};

export default OcChatFooter;

